module.exports = __webpack_public_path__ + "img/6_diamond.9bec2bd9.jpg";